import { encodeQueryValue } from './encodeQueryValue';
import { QueryParam } from './type';

export const buildQueryString = (params: QueryParam[]): string =>
  params
    .map(
      ({ key, value }) =>
        `${encodeURIComponent(key)}=${encodeQueryValue(value)}`,
    )
    .join('&');
